const getRandomId = require('./random-id.js')
const extend = require('xtend')

module.exports = createPayload


function createPayload(data){
  return extend({
    // defaults
    id: getRandomId(),
    jsonrpc: '2.0',
    params: [],
    // user-specified
  }, data)
}



//////////////////
// WEBPACK FOOTER
// ./~/web3-provider-engine/util/create-payload.js
// module id = 221
// module chunks = 0